import React, {useEffect, useState} from 'react'

import {renderMessage} from 'utils/reactUtils'
import NotificationBarView from './NotificationBarView'
import NotificationBarInnerView from './NotificationBarInnerView'
import NotificationBarMobileView from './NotificationBarMobileView'
import NotificationBarMessage from './NotificationBarMessage'
import {NotificationBarIcon, NotificationBarCloseIcon} from './components'
import {NOTIFICATION_TYPES} from 'const/notifications'

const ANIMATION_DURATION = 500
const SUCCESS_CLOSE_DURATION = 2500

const NotificationBar = ({message = '', type = NOTIFICATION_TYPES.error, isDismissible = true, hideNotification}) => {
  const [isOpen, setOpen] = useState(false)
  const closeSuccessAuto = type === NOTIFICATION_TYPES.success

  useEffect(() => {
    setOpen(true)
  }, [])

  const handleClose = () => {
    setOpen(false)

    setTimeout(() => {
      hideNotification()
    }, ANIMATION_DURATION)
  }

  useEffect(() => {
    if (closeSuccessAuto) {
      setTimeout(() => {
        setOpen(false)

        setTimeout(() => {
          hideNotification()
        }, ANIMATION_DURATION)
      }, SUCCESS_CLOSE_DURATION)
    }
  }, [closeSuccessAuto, hideNotification])

  message = renderMessage(message, {onClose: handleClose})

  return (
    <NotificationBarView type={type} isOpen={isOpen} duration={ANIMATION_DURATION / 1000}>
      <NotificationBarInnerView>
        <NotificationBarIcon type={type} />
        <NotificationBarMobileView>
          <NotificationBarMessage>{message}</NotificationBarMessage>
        </NotificationBarMobileView>
        {isDismissible && <NotificationBarCloseIcon type={type} onClick={handleClose} />}
      </NotificationBarInnerView>
    </NotificationBarView>
  )
}

export {NotificationBar as PureNotificationBar}

export default NotificationBar
